import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DynamicCssService {
  private renderer: Renderer2;
  private loadedIds: Set<string> = new Set();
  private linkElements: Map<string, HTMLLinkElement> = new Map();

  constructor(private rendererFactory: RendererFactory2) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  loadStylesheetLink(href: string, linkId: string): Promise<void> {
    return new Promise(resolve => {
      if (!href || !linkId) return resolve();
      if (this.loadedIds.has(linkId) || document.getElementById(linkId)) return resolve();

      const linkEl: HTMLLinkElement = this.renderer.createElement('link');
      linkEl.id = linkId;
      linkEl.rel = 'stylesheet';
      linkEl.href = href;
      linkEl.onload = () => resolve();
      linkEl.onerror = () => resolve();
      this.renderer.appendChild(document.head, linkEl);
      this.linkElements.set(linkId, linkEl);
      this.loadedIds.add(linkId);
    });
  }

  removeStylesheetLink(linkId: string): void {
    const el = this.linkElements.get(linkId) ?? document.getElementById(linkId);
    if (el && document.head.contains(el)) {
      this.renderer.removeChild(document.head, el);
      this.linkElements.delete(linkId);
      this.loadedIds.delete(linkId);
    }
  }
}
